var _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "70 70 350 350",
    width: 30,
    height: 30,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "358.4,216.615 326.892,216.615 326.892,129.969 405.662,129.969 405.662,161.477 358.4,161.477 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "295.385,263.877 263.877,263.877 263.877,185.108 350.523,185.108 350.523,216.615 295.385,216.615 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "240.246,319.015 208.738,319.015 208.738,232.369 295.385,232.369 295.385,263.877 240.246,263.877 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "185.108,382.031 98.462,382.031 98.462,350.523 153.6,350.523 153.6,287.508 240.246,287.508 240.246,319.015 185.108,319.015 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs);
export default __webpack_public_path__ + "static/media/stairs.5bf75129b9f1b21c9fb0502f7d86f13b.svg";
export { ForwardRef as ReactComponent };